// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_31b4x","avatarImage":"_10f45","profileName":"_2D8aw","reply":"SGh4G","user":"_2X5nH","profileInfo":"dmm7f"};